import React, { createContext } from "react"
import { useDisclosure } from "@chakra-ui/react"

const DrawerContext = createContext()

const DrawerProvider = ({ children }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <DrawerContext.Provider
      value={{
        isOpen,
        onOpen,
        onClose,
      }}
    >
      {children}
    </DrawerContext.Provider>
  )
}

export { DrawerContext, DrawerProvider }
